export const fields = () => {
  return {
    companyName: {
      label: 'Search Client',
      value: null,
      // defaultValue: {
      //   label: "",
      //   value: null,
      // },
    },
    franchiseID: {
      label: 'TDDA Supporting Region',
      value: [],
    },
    franchiseOfficeID: {
      label: 'TDDA Supporting Clinic',
      value: [],
    },
    totalStaffNumber: {
      label: 'Company Size',
      type: 'number',
      rules: 'numeric',
      value: null,
    },
    vendorTypeID: {
      label: 'TDDA / Health Tick',
      value: null,
    },
    leadTypeIDs: {
      label: 'Lead Type',
      value: [],
    },
    services: {
      label: 'Services',
      value: [],
    },
    isSLASigned: {
      label: 'Signed SLA',
      value: null,
    },
    slaExpiryDate: {
      label: 'SLA Expiry',
      value: null,
    },
    dealStage: {
      label: 'Deal Stage',
      value: [],
    },
    tddaPrimaryRelationshipManager: {
      label: 'TDDA Primary Relationship Manager',
      value: [],
    },
    healthTickPrimaryRelationshipManager: {
      label: 'HealthTick Primary Relationship Manager',
      value: [],
    },
    piplineValue: {
      label: 'Pipline Value',
      value: {
        min: null,
        max: null,
      },
    },
    inProgressActions: {
      label: 'In Progress actions',
      value: null,
    },
    overdueActions: {
      label: 'Overdue Actions',
      value: null,
    },
    createdBy: {
      label: 'Created By',
      value: [],
    },
    modifiedBy: {
      label: 'Modified By',
      value: {
        label: '',
        value: '',
      },
      defaultValue: {
        label: '',
        value: '',
      },
    },
    primaryContactFullName: {
      label: 'Primary Client Contact Full Name',
      value: '',
    },
    status: {
      label: 'Status',
      value: null,
    },
  };
};
